import { ButtonDS, DialogModalDS } from "@qivia/ui";
import { Spacer } from "@qivia/ui/src/designSystem/components/Spacer";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useNavigate } from "react-router-dom";
import { selectCompany } from "../homeSlice";
import { deleteRuleAsync } from "./rulesSlice";
import { PublicRuleType } from "./rulesAPI";
import "../../../i18n/i18n";

export const DeleteRuleModal = (props: {
  isVisible: boolean;
  onCloseModal: () => void;
  rule: PublicRuleType;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const company = useAppSelector(selectCompany);

  const deleteRule = useCallback(() => {
    if (!company || !props.rule.uuid) return;
    void dispatch(
      deleteRuleAsync({
        uuid: props.rule.uuid,
      }),
    );
    props.onCloseModal();
    navigate(`/home/rules`);
  }, [dispatch, navigate, props, company]);

  return (
    <DialogModalDS
      visible={props.isVisible}
      onClose={() => {
        props.onCloseModal();
      }}
      title={t("rules.delete.modal.title")}
      subTitle={t("rules.delete.modal.content")}
    >
      <StyledModalContainer>
        <Spacer y={0.5} />
        <StyledName>{props.rule.name}</StyledName>
        <Spacer y={2.5} />
        <StyledButtons>
          <ButtonDS
            text={t("rules.delete.modal.button.cancel")}
            onClick={() => {
              props.onCloseModal();
            }}
            buttonType={"secondary"}
            format={"fill"}
          />
          <Spacer x={1.5} />
          <ButtonDS
            text={t("rules.delete.modal.button.confirm")}
            onClick={deleteRule}
            buttonType={"primary"}
            format={"fill"}
          />
        </StyledButtons>
      </StyledModalContainer>
    </DialogModalDS>
  );
};

const StyledModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const StyledButtons = styled.div`
  display: flex;
  width: 100%;
`;

const StyledName = styled.div`
  ${typographies["Body/XL"]};
  color: ${colors["colors/text/darkGrey"]};
`;
